import Datagrid from 'src/components/Datagrid/Datagrid';
import {
  ENTITIES,
  QuerbuilderPayloadColumns,
  QuerbuilderPayloadOrder,
} from 'src/models/QuerybuilderModel';
import DatagridSearch from 'src/components/DatagridSearch/DatagridSearch';
import DatagridToolbar from 'src/components/DatagridToolbar/DatagridToolbar';
import { useEffect } from 'react';
import { setColumns, setOrders } from 'src/redux/actions/querybuilderActions';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { Store, useAppDispatch } from 'src/redux/Store';
import TextLink from 'src/components/UI/TextLink';
import { openModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import { useSelector } from 'react-redux';
import { Preset, PRESET_TYPES } from 'src/models/PresetModel';
import { setSelectedPresets } from 'src/redux/actions/selectedPresetActions';
import { t } from 'src/lib/language';
import { useNavigate } from 'react-router-dom';
import routes, { Route } from 'src/constants/routes';

interface DefaultPreset {
  defaultLayout: Nullable<Preset>,
  defaultLayoutId: number,
}

const entity = ENTITIES.invoices;

const InvoicesPage = () => {
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');
  const user = useSelector((state: Store) => state.user);
  const navigate = useNavigate();
  if (!user.is_admin) {
    navigate(routes[Route.USER_INVOICES].path);
  }

  // PRESET
  const { defaultLayout, defaultLayoutId } = useSelector(
    (state: Store): DefaultPreset => {
      const empty = {
        defaultLayout: null,
        defaultLayoutId: 0,
      } as DefaultPreset;
      const type = PRESET_TYPES.layout;
      if (!state.presets[entity]) return empty;
      if (!state.presets[entity][type]) return empty;
      const storedPreset = state.presets[entity][type].find((preset) => preset.is_default);
      if (storedPreset) {
        return {
          defaultLayout: storedPreset,
          defaultLayoutId: storedPreset.id,
        } as DefaultPreset;
      }
      return empty;
    },
  );

  useEffect(() => {
    dispatch(setSelectedPresets({
      entity,
      type: PRESET_TYPES.layout,
      id: defaultLayoutId,
    }));
    dispatch(setColumns({
      entity,
      columns: defaultLayout?.filter || DEFAULT_COLUMNS[entity],
    } as QuerbuilderPayloadColumns));
    dispatch(setOrders({
      entity,
      order: defaultLayout?.order,
    } as QuerbuilderPayloadOrder));
  }, []);

  return (
    <>
      <DatagridSearch entity={entity} />
      <DatagridToolbar entity={entity} />
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
      }}>
        <TextLink
          id="manage-accounts-link"
          onClick={() => dispatch(openModal({ modal: MODALS.manageAccounts }))}>
          {t(lang, 'forms.invoices.accounts')}
        </TextLink>
        <TextLink
          id="manage-departments-link"
          onClick={() => dispatch(openModal({ modal: MODALS.manageDepartments }))}>
          {t(lang, 'forms.invoices.departments')}
        </TextLink>
        <TextLink
          id="manage-programs-link"
          onClick={() => dispatch(openModal({ modal: MODALS.managePrograms }))}>
          {t(lang, 'forms.invoices.programs')}
        </TextLink>
        <TextLink
          id="manage-products-link"
          onClick={() => dispatch(openModal({ modal: MODALS.manageProducts }))}>
          {t(lang, 'forms.invoices.products')}
        </TextLink>
      </div>
      <Datagrid entity={entity} />
    </>
  );
};

export default InvoicesPage;
